import { TranslateModule } from '@ngx-translate/core';
import { LogService } from '@services/util/log.service';
import { Subject } from 'rxjs';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingsFiltersComponent } from './components/bookings-filters/bookings-filters.component';
import { BookingsTableComponent } from './components/bookings-table/bookings-table.component';
import { BookingFilter } from './models/booking-filter.model';

@Component({
  selector: 'app-bookings',
  standalone: true,
  imports: [BookingsFiltersComponent, BookingsTableComponent, TranslateModule],
  templateUrl: './bookings.component.html'
})
export class BookingsComponent implements OnInit {
  // Current filter state
  currentFilters?: BookingFilter;

  // Subject for cleanup
  private destroy$ = new Subject<void>();

  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly log = inject(LogService);

  ngOnInit(): void {
    this.restoreStateFromUrl();
  }

  /**
   * Handle filter change from the filters component
   *
   * @param filters Filter criteria from BookingsFiltersComponent
   */
  onFilterChange(filters: BookingFilter): void {
    this.currentFilters = filters;
    this.updateUrlParams();
  }

  /**
   * Handle filter reset from the filters component
   */
  onResetFilters(): void {
    this.currentFilters = undefined;
    this.updateUrlParams();
  }

  /**
   * Navigate to booking details page
   *
   * @param id Booking ID to view
   */
  onViewBookingDetails(id: string): void {
    this.router.navigate(['/bookings', id], { state: { from: 'bookings', sourceUrl: this.router.url } });
  }

  private restoreStateFromUrl(): void {
    const params = this.route.snapshot.queryParams;
    if (params['filter']) {
      try {
        const parsed = JSON.parse(params['filter']);
        if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
          this.currentFilters = parsed as BookingFilter;
        }
      } catch (e) {
        this.log.error('Failed to parse filter from URL', e);
      }
    }
  }

  private updateUrlParams(): void {
    const filterValue =
      this.currentFilters && Object.keys(this.currentFilters).length > 0 ? JSON.stringify(this.currentFilters) : null;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { filter: filterValue },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
}
